import React, {Component} from 'react';
import '../CSS/mainPage.css';
import AddNewExpenseModal from '../Modal/AddNewExpense';
import ViewExpensesModal from '../Modal/ViewExpenses';
import {StockDataModal} from '../Modal/StockData';
import * as firebase from "firebase";
import StyledFirebaseAuth from 'react-firebaseui/StyledFirebaseAuth';


// Homme Page of the application
class MainPage extends Component
{
  constructor(props){
    super(props);
    //Modal Show is set to false initially while loading the page
    this.state = { addModalShow1:false,addModalShow2:false,addModalShow4:false}
  }
  //Google Sign In 
  state = { isSignedIn: false }
  uiConfig = {
    signInFlow: "popup",
    signInOptions: [
      firebase.auth.GoogleAuthProvider.PROVIDER_ID,
    ],
    callbacks: {
      signInSuccess: () => false
    }
  }
//Checking the authenticated user
  componentDidMount = () => {
    firebase.auth().onAuthStateChanged(user => {
      this.setState({ isSignedIn: !!user })
      console.log("user", user)
    })
  }

  render()
  {
    //Modal Close is set to false initially while loading the page
    let addModalClose1 =() => this.setState({addModalShow1:false});
    let addModalClose2 =() => this.setState({addModalShow2:false});
    let addModalClose4 =() => this.setState({addModalShow4:false});
    
    
    return(
      <header>
      <div className="bindDiv">
      <img className="avatar"/>
      <h1> Expense Panda</h1>
      {/* App description*/}
      <p className="pinfo">Are you someone who tends to go over their weekly budget? Tend to spend more money on coffee and food than the average person? Or are unable to resist the urge to buy the latest version of something you already have three of at home? We can help!</p>
      <p className="pinfo">With Expense Panda we aim to help you manage your personal expenses. Say you just spent $5.00 on a coffee, simply remember to log it in to our application after spending the money. </p>
      <p className="pinfo">Interested in stock prices by any chance? Look no further as Expense Panda lets you a wide range of stock prices around the world, this saves you the hassle of going to a different website to check on this.</p>
      <p className="pinfo">Once you start using Expense Panda we look forward to seeing you cut back on your expenses, maintaining your weekly budget and avoiding unnecessary expenditure.</p><br/>
      
      <div>
      {/* If user is signed In, it provides access to the functionalities*/}
      {this.state.isSignedIn ? (
        <span>
        <div className = "DetailsDiv">
        <img
        alt="profile picture"
        src={firebase.auth().currentUser.photoURL}
        className = "profilePic"/>
        {/* Displays user name based on logged In user*/}
        <h1 id = "WelcomeText" className= "WelcomeText">Welcome {firebase.auth().currentUser.displayName} </h1>
        <button className = "SignOut" onClick={() => firebase.auth().signOut()}>Sign Out</button>
        
        </div> 
        
        <div className = "AddExpenseDiv">
        {/* On Click of button AddExpense Modal is opened and closed on click of cancel button*/}
            <button className = "AddExpense" onClick = {()=>this.setState({addModalShow1:true})}>Add New Expense</button>
           {/* Each Modal is component and is present under Modal folder*/}
            <AddNewExpenseModal
            show={this.state.addModalShow1} 
            onHide={addModalClose1}
            />
            </div>
        <div className = "ViewExpensesDiv">
        {/* On Click of button ViewExpense Modal is opened closed on click of Close button*/}
          <button className ="ViewExpenses" onClick = {()=>this.setState({addModalShow2:true})}>View Expenses</button>
           {/* Each Modal is component and is present under Modal folder*/}
           <ViewExpensesModal
          show = {this.state.addModalShow2}
          onHide = {addModalClose2}
          />
        </div>
        <div className = "StockDataDiv">
        {/* On Click of button StockData Modal is opened closed on click of Close button*/}
          <button className="StockData"onClick = {()=>this.setState({addModalShow4:true})}>View Live Stock Data</button>
           {/* Each Modal is component and is present under Modal folder*/}
          <StockDataModal
          show = {this.state.addModalShow4}
          onHide = {addModalClose4}
          />
        </div>
        
       </span>
        ) : (
        <StyledFirebaseAuth
          uiConfig={this.uiConfig}
          firebaseAuth={firebase.auth()}
        />
      )}
      </div>
      </div>
      </header>
      );
    }
        }       
export default MainPage